import { Controller } from '@hotwired/stimulus';
import { tns as TinySlider } from 'tiny-slider/src/tiny-slider.module';

export default class extends Controller {
    static targets = ['container'];

    connect () {
        if (!this.hasContainerTarget) {
            return;
        }

        this.$slider = TinySlider({
            container: this.containerTarget,
            mode: 'gallery',
            speed: 1000,
            controls: false,
            navPosition: 'bottom',
            autoplay: true,
            autoplayButtonOutput: false,
        });

        const updateHeight = () => {
            const texts = document.querySelectorAll('.news-slider__headline');
            let height = 0;
            texts.forEach(((el) => {
                el.style.height = 'auto';
                height = Math.max(height, el.clientHeight);
            }));
            texts.forEach((el) => {
                el.style.height = `${height}px`;
            })
            this.$slider.updateSliderHeight();
        }

        let timeout = false;
        window.addEventListener('resize', () => {
            clearTimeout(timeout);
            timeout = setTimeout(updateHeight, 250);
        })
        updateHeight();
    }
}
